<template>
  <!--Login Page-->
  <v-app>
    <v-content>
      <v-row class="fill-height">
        <v-col class="text-center align-self-center">
          <span style="text-transform: uppercase;">{{
            $t("Forgot Password")
          }}</span>
          <div class="errormsg" v-if="$route.query.message">
            {{ $route.query.message }}
          </div>

          <v-card
            class="mx-auto"
            style="background-color: #eeeeee; padding:25px; border-radius: 4px; border: 3px solid #dddddd;"
            :style="{ width: $vuetify.breakpoint.xs ? '100%' : '400px' }"
          >
            <v-row>
              <v-alert :value="checkyourmail" type="success">
                Please check your mail for link for instructions to get new
                password.
              </v-alert>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-col class="pl-12 ml-12">
                <router-link to="/front" style="text-decoration:none;">
                  <v-btn large icon color="error" outlined>
                    <v-icon large>fas fa-times</v-icon>
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
            <router-link to="/front">
              <v-img src="/wenewz_middle_2color.svg" />
            </router-link>
            <v-form @submit.prevent="submitForgottenPassword" class="pt-5">
              <v-text-field
                v-if="!setnewpassword"
                :label="$t('Email')"
                v-model="username"
                required
                :rules="[(v) => !!v || this.$t('Email Required')]"
              ></v-text-field>
              <v-text-field
                v-if="setnewpassword"
                :label="$t('New password')"
                v-model="password"
                type="password"
                required
                :rules="[(v) => !!v || this.$t('Password are Required')]"
              ></v-text-field>
              <v-text-field
                v-if="setnewpassword"
                :label="$t('Repeat password')"
                v-model="password2"
                type="password"
                required
                :rules="[
                  (v) => v == password || this.$t('Password doesnt match'),
                ]"
              ></v-text-field>
              <v-btn block type="submit" :disabled="!username" class="mt-5">{{
                setnewpassword ? 
                $t("Confirm new password") :
                $t("Ask for new password")
              }}</v-btn>
            </v-form>
            <v-divider></v-divider>
            <div class="body-1 pt-2">
              <span>
                <router-link to="/login">{{
                  $t("Go back to login")
                }}</router-link>
              </span>
            </div>
            <div class="body-1 pt-2">
              <span>
                <router-link to="/register">{{
                  $t("Create account")
                }}</router-link>
              </span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-content>
  </v-app>
</template>

<script>
import messages from "./modules/lang/export";
export default {
  i18n: { messages },
  data() {
    return {
      username: "",
      password: "",
      password2: "",
      errormsg: "",
      successmsg: "",
      errormsgtimer: null,
      successmsgtimer: null,
      checkyourmail: false,
      setnewpassword: false,
    };
  },
  watch: {
    errormsg() {
      clearTimeout(this.errormsgtimer);
      if (this.errormsg != "") {
        alert(this.errormsg);
        this.errormsgtimer = setTimeout(() => {
          this.errormsg = "";
        }, 3000);
      }
    },
    successmsg() {
      clearTimeout(this.successmsgtimer);
      if (this.successmsg != "") {
        this.successmsgtimer = setTimeout(() => {
          this.successmsg = "";
        }, 3000);
      }
    },
  },
  methods: {
    submitForgottenPassword() {
      if (this.setnewpassword) {
        if (this.password == this.password2) {
          let _userobj = {
            username: this.username,
            password: this.password,
            guid: this.$route.params.guid,
          };
          console.log({_userobj});
          this.$store
            .dispatch("setnewpassword", _userobj)
            .then((resp) => {
              console.log({resp});
              // this.successmsg = resp;
              // this.checkyourmail = true;
              alert("Password set, please login with the new credentials.");
              this.$router.push("/login");
            })
            .catch((err) => {
              alert(
                "some error occured, if you get this error again then please request new password."
              );

              console.error(err);
              this.errormsg = err;
            });
        } else {
          this.errormsg = "Password doesnt match";
          console.error(this.errormsg);
        }
      } else {
        let _userobj = { username: this.username };
        this.$store
          .dispatch("forgotpassword", _userobj)
          .then((resp) => {
            console.log(resp);
            this.successmsg = resp;
            this.checkyourmail = true;
          })
          .catch((err) => {
            alert("some error occured, sure you entered the correct email?");
            console.error(err);
            this.errormsg = err;
          });
      }
    },
  },
  mounted() {
    if (this.$route.query.user) {
      this.username = this.$route.query.user;
    }
    console.log(this.$route.params.guid);
    if (this.$route.params.guid) {
      let _userobj = { guid: this.$route.params.guid };
      this.$store
        .dispatch("validateforgotpasswordtoken", _userobj)
        .then((resp) => {
          this.successmsg = resp;
          this.username = resp;
          this.setnewpassword = true;

          console.log(resp);
        })
        .catch((err) => {
          console.error(err);
          this.errormsg = err;
        });
    }
  },
};
</script>

<style scoped>
.errormsg {
  position: absolute;
  top: 0;
  width: 100;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #cc0000;
  color: white;
  border-bottom: 2px solid red;
}
</style>
